import API from "@/api/lib/api";

export const getAllCrusts = async (restaurant_id, menu_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/crusts/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleCrustById = async (id) => {
  try {
    const response = await API.get(`restaurant/crusts/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createCrust = async (data) => {
  try {
    const response = await API.post(`restaurant/crusts`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateCrust = async (id, data) => {
  try {
    const response = await API.put(`restaurant/crusts/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteCrust = async (id) => {
  try {
    const response = await API.delete(`restaurant/crusts/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};